<template>
  <div id="event-gallery-container">
    <h1 class="hero-title">Featured Conferences & Expos</h1>

    <div
        class="carousel-wrapper"
        @mouseenter="pauseAutoSlide"
        @mouseleave="resumeAutoSlide"
        @touchstart="onTouchStart"
        @touchend="onTouchEnd"
    >
      <div class="carousel-content">
        <v-btn class="carousel-button" icon @click="prevSlide">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>

        <v-row class="card-row" justify="center" align="stretch" no-gutters>
          <v-col
              v-for="(item, i) in visibleItems"
              :key="i"
              cols="12"
              :sm="perView === 1 ? 12 : perView === 2 ? 6 : 4"
          >
            <v-card
                :href="item.link"
                target="_blank"
                class="card-container"
            >
              <v-img
                  :src="item.background"
                  height="300px"
                  class="white--text d-flex align-end"
                  gradient="to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.7)"
              >
                <div class="card-overlay">
                  <v-card-title :style="{ color: item.color }">
                    {{ item.title }}
                  </v-card-title>
                  <v-card-subtitle :style="{ color: item.color }">
                    {{ item.description }}
                  </v-card-subtitle>
                </div>
              </v-img>
            </v-card>
          </v-col>
        </v-row>

        <v-btn class="carousel-button" icon @click="nextSlide">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </div>

  </div>
</template>


<script>
export default {
  data() {
    return {
      startIndex: 0,
      perView: 3, // default, will be responsive
      autoSlideInterval: null, // store the interval ID
      itemCard: [
        {
          title: 'We Make Future 2025',
          description: 'The Biggest International Fair and Festival on Artificial Intelligence, Technology & Digital Innovation',
          background: require("../../assets/events/wmf2025.png"),
          link: 'https://www.wemakefuture.it/'
        },
        {
          title: 'RiminiWellness 2025',
          description: 'Annual wellness event with fitness innovations and industry showcases',
          background: require("../../assets/events/rw2025.png"),
          link: 'https://www.linkedin.com/posts/riminiwellness_rw25-riminiwellness-faceyourshades-activity-7318568770468245504-xkqn'
        },
        {
          title: 'Svilupparty 2025',
          description: 'Svilupparty is an event created to celebrate the work of Italian video game developers',
          background: require("../../assets/events/svilupparty.png"),
          link: "https://www.instagram.com/svilupparty/p/DI_KQYRoRQS"
        },
        {
          title: '3DBODY.TECH 2024',
          description: 'Leading international event on 3D body scanning and processing technologies',
          background: require("../../assets/events/3dbodytech.png"),
          link: 'https://www.linkedin.com/posts/nicola-dapuzzo-phd_3dbodytech-conference-expo-2024-flashback-activity-7316017026471215106-oKGU'
        },
        {
          title: 'RiminiWellness 2024',
          description: 'Top fitness and wellness expo with new trends, products, and live demos',
          background: require("../../assets/events/rw2024.png"),
          link: 'https://www.linkedin.com/posts/riminiwellness_rw25-riminiwellness-faceyourshades-activity-7318568770468245504-xkqn'
        },
      ]
    };
  },
  computed: {
    visibleItems() {
      return this.itemCard.slice(this.startIndex, this.startIndex + this.perView);
    },
    endReached() {
      return this.startIndex + this.perView >= this.itemCard.length;
    }
  },
  methods: {
    pauseAutoSlide() {
      clearInterval(this.autoSlideInterval);
      this.autoSlideInterval = null;
    },
    resumeAutoSlide() {
      if (!this.autoSlideInterval) {
        this.autoSlideInterval = setInterval(() => {
          this.nextSlide();
        }, 7000);
      }
    },
    nextSlide() {
      if (this.startIndex + this.perView >= this.itemCard.length) {
        this.startIndex = 0; // wrap to beginning
      } else {
        this.startIndex++;
      }
    },
    prevSlide() {
      if (this.startIndex === 0) {
        this.startIndex = Math.max(this.itemCard.length - this.perView, 0); // wrap to end
      } else {
        this.startIndex--;
      }
    },
    handleResize() {
      const width = window.innerWidth;
      if (width <= 768) {
        this.perView = 1;       // Mobile
      } else if (width < 1440) {
        this.perView = 2;       // Tablet
      } else {
        this.perView = 3;       // Desktop
      }
    },
    onTouchStart(e) {
      this.touchStartX = e.changedTouches[0].screenX;
    },
    onTouchEnd(e) {
      this.touchEndX = e.changedTouches[0].screenX;
      this.handleSwipeGesture();
    },
    handleSwipeGesture() {
      const swipeDistance = this.touchEndX - this.touchStartX;
      const swipeThreshold = 50; // Minimum distance to count as swipe

      if (swipeDistance > swipeThreshold) {
        // Swipe right → go to previous slide
        this.prevSlide();
      } else if (swipeDistance < -swipeThreshold) {
        // Swipe left → go to next slide
        this.nextSlide();
      }
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    this.resumeAutoSlide()
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    this.pauseAutoSlide()
  }
};
</script>
<style scoped lang="scss">
#event-gallery-container {
  //padding: 0 0 4rem;
  //padding: 1.3rem;
  text-align: center;
}

.hero-title {
  font-size: clamp(1.8rem, 5vw, 4rem);
  margin: 3% 0 1% 0;
  font-weight: bold;
  //font-size: 4rem;
  //margin: 3% 0;
  //margin: 3% 0 1% 0;
  //font-weight: bold;
  text-align: center;
  background: linear-gradient(180deg, #f8f8ff, rgba(248, 248, 255, 0.5));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
  //margin-bottom: 2rem;
}

.carousel-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: nowrap;
  overflow: hidden;
}

.carousel-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 0.5rem;
}

//.card-row {
//  flex: 1;
//}


.card-row {
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
  transition: transform 0.3s ease;
  gap: 1rem;
  width: 100%;
  max-width: 1200px;
}

.card-container {
  height: 100%;
  overflow: hidden;
}

//.card-overlay {
//  background-color: rgba(0, 0, 0, 0.5);
//  width: 100%;
//  padding: 1rem;
//}

.card-overlay {
  background-color: rgba(0, 0, 0, 0.6);
  //width: 100%;
  //padding: 1.5rem 1rem;
  text-align: left;

  .v-card-title {
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1.2;
    margin-bottom: 0.3rem;
    color: #fff !important;
  }

  .v-card-subtitle {
    font-size: 1rem;
    line-height: 1.4;
    color: #e0e0e0 !important;
  }
}


.v-btn {
  background-color: #ffffff !important;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  min-width: 40px;
  height: 40px;
}

.v-icon {
  color: #333;
  font-size: 24px;
}

/* Responsive tweaks */
@media screen and (max-width: 425px) {
  .carousel-button {
    display: none !important;
  }
}


@media screen and (max-width: 768px) {
  .card-row {
    flex-direction: column;
    align-items: center;
  }

  .carousel-wrapper {
    flex-direction: column;
  }

  .v-btn {
    margin: 1rem 0;
  }
}

//@media screen and (max-width: 1280px) {
//  .hero-title {
//    font-size: 2rem;
//    //margin-top: 5%;
//  }
//}

</style>
